import React from 'react';
import { string } from 'prop-types';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';
import Col from 'react-bootstrap/Col';
import { useQuery } from 'react-query';
import { phrApi } from '../../api/api';

function PatientOTP(props) {
  // TODO: handle error
  const { phrPatientId } = props;
  const { isLoading, error, data, refetch } = useQuery('patientOTP', () => phrApi('get', `patient/${phrPatientId}/web_passcode`), {
    enabled: !!phrPatientId,
  });

  const webPasscode = data?.data?.webPasscode;

  function checkWebPassCodeValue() {
    if (webPasscode === 0) {
      return "Patient hasn't logged in yet";
    } else if (!webPasscode) {
      return 'Please refresh the OTP';
    }
    return webPasscode;
  }

  if (isLoading) {
    return <Spinner animation={'border'} />;
  }

  return (
    <Row>
      <Col xs={12}>
        <div className={'d-flex flex-row my-3'}>
          <Button variant={'primary'} size={'sm'} className={'mr-2'}>
            {checkWebPassCodeValue()}
          </Button>
          <Button variant={'fff'} size={'sm'} onClick={refetch}>
            Refresh OTP
          </Button>
        </div>
      </Col>
    </Row>
  );
}

PatientOTP.propTypes = {
  phrPatientId: string,
};
PatientOTP.defaultProps = {};

export default PatientOTP;
